import { logError } from "./errorTelemetry";

const PLACEHOLDER = "/placeholder.svg";

/**
 * Scans the DOM for broken images and substitutes placeholders.
 * Should be called once after page load on public pages.
 */
export function initAssetMonitor() {
  // Wait for page to settle
  const run = () => {
    // Check all images
    const images = document.querySelectorAll("img");
    images.forEach((img) => {
      if (img.complete && img.naturalWidth === 0 && img.src && !img.src.includes("data:")) {
        logError("broken_asset", `Broken image: ${img.src}`, img.src);
        img.src = PLACEHOLDER;
        img.alt = img.alt || "Image unavailable";
      }
    });

    // Listen for future image errors
    document.addEventListener(
      "error",
      (e) => {
        const target = e.target as HTMLElement;
        if (target.tagName === "IMG") {
          const img = target as HTMLImageElement;
          if (img.src && !img.src.endsWith(PLACEHOLDER)) {
            logError("broken_asset", `Broken image: ${img.src}`, img.src);
            img.src = PLACEHOLDER;
          }
        }
      },
      true // capture phase to catch img errors
    );

    // Check fonts
    if (document.fonts) {
      document.fonts.ready.then(() => {
        const fontsToCheck = ["Inter", "DM Sans", "Plus Jakarta Sans"];
        fontsToCheck.forEach((font) => {
          if (!document.fonts.check(`16px "${font}"`)) {
            logError("broken_asset", `Font not loaded: ${font}`, font);
          }
        });
      });
    }
  };

  if (document.readyState === "complete") {
    setTimeout(run, 1000);
  } else {
    window.addEventListener("load", () => setTimeout(run, 1000));
  }
}
